import { useState, useContext, useEffect } from "react";
import "../../../styles/index.css";
import "./add-a-user.css";
import AppContext from "../../../context/app-context";
import { popup } from "../../../vanilla-functions/model";
import { AiOutlineCloseCircle } from "react-icons/ai";

const AddAnEstateUserModal = function ({ display, setAddAnEstateUserModal, url, updateState }) {
  const { setIsLoading, validateEmail, validateMobile } = useContext(AppContext);
  const [disableBtn, setDisableBtn] = useState(false);

  const [whatsWrong, setWhatsWrong] = useState("");

  const [firstName, setfirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const [mobile, setmobile] = useState("");
  const [email, setemail] = useState("");
  const [houseNumber, sethouseNumber] = useState("");
  const [streetName, setStreetName] = useState("");

  useEffect(() => {
    runValidation();

    if (
      !firstName ||
      !lastName ||
      !email ||
      !validateEmail(email) ||
      !validateMobile(mobile) ||
      !mobile ||
      !houseNumber ||
      !streetName
    )
      setDisableBtn(true);
    else setDisableBtn(false);
  });

  function runValidation() {
    if (!firstName) return setWhatsWrong("First name is requried");
    if (!lastName) return setWhatsWrong("Last name is requried");
    if (!email || !validateEmail(email)) return setWhatsWrong("Email is missing or invalid");
    if (!mobile || !validateMobile(mobile))
      return setWhatsWrong("Mobile Number is missing or invalid");

    if (!houseNumber) return setWhatsWrong("Set a house number for the resident");
    if (!streetName) return setWhatsWrong("Set a street name for the resident");

    setWhatsWrong("");
  }

  async function addUser() {
    try {
      setIsLoading(true);
      const returned = await (
        await fetch(`${url}/signup/user`, {
          method: "POST",
          credentials: "include",
          headers: {
            token: localStorage.getItem("omstoken"),
            "content-type": "application/json",
          },
          body: JSON.stringify({
            first_name: firstName,
            last_name: lastName,
            email: email,
            mobile: mobile,
            address: {
              addressString: `${houseNumber}, ${streetName} `,
              geoLocation: {
                coordinates: ["", ""],
              },
              postCode: "000000",
            },
            login_token: {
              token_id: "1",
              token: "1",
            },
          }),
        })
      ).json();

      if (returned.status === "Internal server error") throw new Error(returned.message);

      setIsLoading(false);

      popup("Resident Added");
      setfirstName("");
      setlastName("");
      setmobile("");
      setemail("");
      sethouseNumber("");
      setStreetName("");
      updateState && updateState(returned?.data);
      setAddAnEstateUserModal(false);
    } catch (err) {
      setIsLoading(false);
      popup("Error creating resident, try again later");
    }
  }

  return (
    <div
      className="modal-container modal-on-modal-container"
      style={{ display: `${display && url ? "flex" : "none"}` }}
    >
      <div className="modal-body modal-on-modal-body">
        <div className="close-container-modal">
          <AiOutlineCloseCircle
            onClick={() => {
              setAddAnEstateUserModal(false);
            }}
            className="cursor"
            size={20}
            color="#34204C"
          />
        </div>

        <div className="flex-column align-column-left cd-add-user-in-cont">
          <div className="flex-row">
            <p className="big removemargin aa-user-border-color boldText">Add Resident</p>
          </div>

          <div className="flex-row">
            <input
              className="in a-a-u-inputs"
              placeholder="First Name"
              type="text"
              value={firstName}
              onChange={(e) => setfirstName(e.target.value)}
            />
            <input
              className="in a-a-u-inputs"
              placeholder="Last Name"
              type="text"
              maxLength="100"
              value={lastName}
              onChange={(e) => setlastName(e.target.value)}
            />
          </div>

          <div className="flex-row">
            <input
              className="in a-a-u-inputs"
              placeholder="Email"
              type="email"
              maxLength="100"
              value={email}
              onChange={(e) => {
                setemail(e.target.value);
              }}
            />
            <input
              className="in a-a-u-inputs"
              placeholder="Mobile"
              type="text"
              value={mobile}
              onChange={(e) => {
                setmobile(e.target.value);
              }}
            />
          </div>

          <div className="flex-row">
            <input
              className="in a-a-u-inputs"
              placeholder="House Number"
              type="text"
              maxLength="100"
              value={houseNumber}
              onChange={(e) => {
                sethouseNumber(e.target.value);
              }}
            />
            <input
              className="in a-a-u-inputs"
              placeholder="Street Name"
              type="text"
              value={streetName}
              onChange={(e) => {
                setStreetName(e.target.value);
              }}
            />
          </div>
        </div>

        <div className="flex-column" style={{ gap: 5, marginTop: 40 }}>
          <button disabled={disableBtn} onClick={addUser} className="themeBtn a-a-u-btn">
            Create Resident
          </button>
          <p className="redText small">{whatsWrong}</p>
        </div>
      </div>
    </div>
  );
};

export default AddAnEstateUserModal;
